module.exports = __webpack_public_path__ + "static/media/whitereminderscheck.2e615f35.svg";